import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import { AttachFile } from "@styled-icons/material";
import { AttachedListItem, AttachIcon } from "./AttachedFile";

const JunoUploadedFileList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin: 0;
`;

/**
 * Names the files a client has uploaded. Read only: the review and completed views show
 * what is attached, FileUploadQuestion is where a client changes it.
 */
const UploadedFileList = ({ uploads }) => {
  if (!uploads || uploads.length === 0) {
    return null;
  }

  return (
    <JunoUploadedFileList>
      {uploads.map((upload, index) => (
        <AttachedListItem key={`uploaded_file_${index}`}>
          <AttachIcon>
            <AttachFile size="24" />
          </AttachIcon>
          <span>{upload.filename}</span>
        </AttachedListItem>
      ))}
    </JunoUploadedFileList>
  );
};

UploadedFileList.propTypes = {
  uploads: PropTypes.arrayOf(
    PropTypes.shape({
      filename: PropTypes.string.isRequired,
    }),
  ),
};

export default UploadedFileList;
